import { render, staticRenderFns } from "./transtable.vue?vue&type=template&id=0081449c&scoped=true&"
import script from "./transtable.vue?vue&type=script&lang=js&"
export * from "./transtable.vue?vue&type=script&lang=js&"
import style0 from "./transtable.vue?vue&type=style&index=0&id=0081449c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081449c",
  null
  
)

export default component.exports